export default "__VITE_ASSET__4iHubTRz__"